import { render, staticRenderFns } from "./SendError.vue?vue&type=template&id=1fcc94b8"
import script from "./SendError.vue?vue&type=script&lang=js"
export * from "./SendError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports